import { createContext, useCallback, useContext, useState } from 'react';

type Kind = 'ok' | 'err' | 'info';
interface Toast { id: number; text: string; kind: Kind; leaving?: boolean }

const Ctx = createContext<(text: string, kind?: Kind) => void>(() => {});
export const useToast = () => useContext(Ctx);

export function ToastProvider({ children }: { children: React.ReactNode }) {
  const [items, setItems] = useState<Toast[]>([]);

  const push = useCallback((text: string, kind: Kind = 'info') => {
    const id = Date.now() + Math.random();
    setItems((prev) => [...prev, { id, text, kind }]);
    // Mark leaving first so rtToastOut can play before removal.
    setTimeout(() => {
      setItems((prev) => prev.map((t) => (t.id === id ? { ...t, leaving: true } : t)));
      setTimeout(() => setItems((prev) => prev.filter((t) => t.id !== id)), 220);
    }, 2600);
  }, []);

  return (
    <Ctx.Provider value={push}>
      {children}
      {items.map((t, i) => (
        <div
          key={t.id}
          className={[
            'rt-toast',
            t.kind === 'ok' ? 'rt-toast--ok' : '',
            t.kind === 'err' ? 'rt-toast--err' : '',
            t.leaving ? 'rt-toast--out' : '',
          ].filter(Boolean).join(' ')}
          style={{ bottom: 24 + i * 46 }}
          role="status"
        >
          {t.text}
        </div>
      ))}
    </Ctx.Provider>
  );
}
